import { useEffect } from "react";

export function usePageMeta({
  title,
  favicon,
  description,
}: {
  title?: string;
  favicon?: string;
  description?: string;
}) {
  useEffect(() => {
    if (title) document.title = title;
    if (description)
      document
        .querySelector("meta[name='description']")
        ?.setAttribute("content", description);
    if (favicon) {
      const link =
        document.querySelector("link[rel~='icon']") ||
        Object.assign(document.createElement("link"), { rel: "icon" });
      document.head.appendChild(link);
      link.href = favicon;
    }
  }, [title, favicon, description]);
}
